// AUTO-GENERATED FILE. DO NOT EDIT MANUALLY.

export const Home = (): string => `/`

export const Join = (groupCode: string): string => `/join/${groupCode}`

export const Claim = (inviteKey: string): string => `/claim/${inviteKey}`

export const FormInvite = (formInviteKey: string): string => `/form-invite/${formInviteKey}`

export const CustomerUpload = (orgID: string, importID: string, token: string): string => `/customer-upload/${orgID}/${importID}/${token}`

export const Verify = {
	"Membership": (userProductId: number, timestamp: string, signature: string): string => `/verify/${userProductId}/${timestamp}/${signature}`
}

export const Group = {
	"Change": (): string => `/group-change`,
	"Post": {
		"Show": (organizationId: number, id: number): string => `/organization/${organizationId}/group/post/${id}`,
		"ListCopies": (organizationId: number, id: number): string => `/organization/${organizationId}/group/post/${id}/copies`,
		"Index": (organizationId: number, groupId: number, currentTab: string): string => `/organization/${organizationId}/communication/${groupId}/posts/${currentTab}`
	},
	"Show": (organizationId: number, groupId: number): string => `/organization/${organizationId}/group/${groupId}`,
	"Wall": (organizationId: number, groupId: number): string => `/organization/${organizationId}/group/${groupId}/wall`
}

export const Notifications = {
	"Index": (): string => `/notifications`,
	"History": (currentTab: string): string => `/notifications/${currentTab}`
}

export const Account = {
	"Settings": {
		"Show": (currentTab: string): string => `/account/settings/${currentTab}`
	}
}

export const Organization = {
	"Home": (organizationId: number): string => `/organization/${organizationId}`,
	"Registrations": {
		"Activities": (organizationId: number, groupId: number, formId: number, eventGroupId: number): string => `/organization/${organizationId}/registrations/${groupId}/${formId}/activities/${eventGroupId}`
	},
	"Settings": {
		"Sso": (organizationId: number): string => `/organization/${organizationId}/settings/sso`,
		"Payments": (organizationId: number): string => `/organization/${organizationId}/settings/payments`,
		"UserFields": (organizationId: number): string => `/organization/${organizationId}/settings/user-fields`,
		"Agreements": {
			"Index": (organizationId: number): string => `/organization/${organizationId}/settings/agreements`,
			"Archived": (organizationId: number): string => `/organization/${organizationId}/settings/agreements/archived`,
			"Consents": (organizationId: number): string => `/organization/${organizationId}/settings/agreements/consents`,
			"Show": (organizationId: number, agreementId: number): string => `/organization/${organizationId}/settings/agreements/${agreementId}`
		},
		"Website": (organizationId: number): string => `/organization/${organizationId}/settings/websites`,
		"Websites": {
			"Show": (organizationId: number, siteId: number): string => `/organization/${organizationId}/settings/websites/${siteId}`
		}
	},
	"Development": {
		"Assessments": (organizationId: number, groupId: number): string => `/organization/${organizationId}/development/${groupId}/assessments`,
		"PerformanceReviews": (organizationId: number, groupId: number): string => `/organization/${organizationId}/development/${groupId}/performance-reviews`
	},
	"Events": (organizationId: number, eventId: number): string => `/organization/${organizationId}/events/${eventId}`,
	"Videos": {
		"Edit": (organizationId: number, videoId: number): string => `/organization/${organizationId}/videos/${videoId}/edit`
	},
	"UserGroups": {
		"Capabilities": (organizationId: number, userGroupId: number): string => `/organization/${organizationId}/user-groups/${userGroupId}/capabilities`
	},
	"User": {
		"Profile": {
			"Show": (organizationId: number, userId: number, currentTab: string): string => `/organization/${organizationId}/user/${userId}/${currentTab}`
		}
	}
}

export const Network = {
	"Members": (organizationId: number): string => `/organization/${organizationId}/network/members`,
	"Payments": (organizationId: number): string => `/organization/${organizationId}/network/payments`,
	"Registrations": (organizationId: number): string => `/organization/${organizationId}/network/registrations`,
	"Attendance": (organizationId: number): string => `/organization/${organizationId}/network/attendance`,
	"Training": (organizationId: number): string => `/organization/${organizationId}/network/training`,
	"Posts": (organizationId: number): string => `/organization/${organizationId}/network/posts`,
	"NewPost": (organizationId: number): string => `/organization/${organizationId}/network/posts/new`,
	"EditPost": (organizationId: number, postId: number): string => `/organization/${organizationId}/network/posts/${postId}/edit`,
	"Post": (organizationId: number, postId: number): string => `/organization/${organizationId}/network/posts/${postId}`,
	"Settings": (organizationId: number): string => `/organization/${organizationId}/network/settings`,
	"SettingsTab": (organizationId: number, currentTab: string): string => `/organization/${organizationId}/network/settings/${currentTab}`,
	"Club": (organizationId: number, clubId: number, currentTab: string): string => `/organization/${organizationId}/network/clubs/${clubId}/${currentTab}`
}

export const Payments = {
	"Overview": (organizationId: number): string => `/organization/${organizationId}/payments/overview`,
	"Revenue": (organizationId: number): string => `/organization/${organizationId}/payments/revenue`,
	"Orders": (organizationId: number): string => `/organization/${organizationId}/payments/orders`,
	"Subscriptions": (organizationId: number): string => `/organization/${organizationId}/payments/subscriptions`,
	"Payouts": (organizationId: number): string => `/organization/${organizationId}/payments/payouts`,
	"Balance": (organizationId: number): string => `/organization/${organizationId}/payments/balance`,
	"Fritidskortet": (organizationId: number): string => `/organization/${organizationId}/payments/fritidskortet`
}

export const Payout = {
	"Index": (organizationId: number, id: number): string => `/organization/${organizationId}/payments/payouts/${id}`
}

export const Taxes = {
	"Index": (organizationId: number): string => `/organization/${organizationId}/payments/tax-rates`
}

export const Discounts = {
	"Index": (organizationId: number): string => `/organization/${organizationId}/payments/discounts`,
	"Create": (organizationId: number): string => `/organization/${organizationId}/payments/discounts/create`,
	"Edit": (organizationId: number, id: number): string => `/organization/${organizationId}/payments/discounts/${id}/edit`
}

export const Disputes = {
	"Index": (organizationId: number): string => `/organization/${organizationId}/payments/disputes`
}

export const Families = {
	"Index": (organizationId: number): string => `/organization/${organizationId}/payments/families`,
	"Create": (organizationId: number): string => `/organization/${organizationId}/payments/families/create`,
	"Detail": (organizationId: number, id: number): string => `/organization/${organizationId}/payments/families/${id}`
}

export const Refunds = {
	"Index": (organizationId: number): string => `/organization/${organizationId}/payments/refunds`
}

export const CreditNotes = {
	"Index": (organizationId: number): string => `/organization/${organizationId}/payments/credit-notes`
}

export const Products = {
	"Index": (organizationId: number): string => `/organization/${organizationId}/payments/products`,
	"Archived": (organizationId: number): string => `/organization/${organizationId}/payments/products/archived`
}

export const Product = {
	"Create": (organizationId: number): string => `/organization/${organizationId}/payments/products/new-product`,
	"Edit": (organizationId: number, productId: number): string => `/organization/${organizationId}/payments/products/edit/${productId}`,
	"Show": (organizationId: number, productId: number, currentTab: string): string => `/organization/${organizationId}/payments/products/${productId}/${currentTab}`
}

export const Invoice = {
	"New": (organizationId: number): string => `/organization/${organizationId}/payments/new-order`
}

export const Subscription = {
	"Edit": (organizationId: number, id: number): string => `/organization/${organizationId}/payments/subscription/${id}/edit`,
	"Show": (organizationId: number, id: number, currentTab: string): string => `/organization/${organizationId}/payments/subscription/${id}/${currentTab}`
}

export const Order = {
	"Show": (organizationId: number, id: number): string => `/organization/${organizationId}/payments/order/${id}`
}

export const CreditNote = {
	"Show": (organizationId: number, id: number): string => `/organization/${organizationId}/payments/credit-note/${id}`
}

export const AiAssistant = {
	"Index": (organizationId: number): string => `/organization/${organizationId}/ai-assistant`,
	"Show": (organizationId: number, conversationId: number): string => `/organization/${organizationId}/ai-assistant/${conversationId}`
}

export const Chat = {
	"Index": (organizationId: number): string => `/organization/${organizationId}/chat`,
	"Monitored": {
		"Index": (organizationId: number, targetAccountId: number): string => `/organization/${organizationId}/chat/monitored/${targetAccountId}`,
		"Show": (organizationId: number, targetAccountId: number, targetChatId: number): string => `/organization/${organizationId}/chat/monitored/${targetAccountId}/${targetChatId}`
	},
	"New": (organizationId: number): string => `/organization/${organizationId}/chat/new`,
	"Show": (organizationId: number, targetChatId: number): string => `/organization/${organizationId}/chat/${targetChatId}`
}

export const Calendar = {
	"Index": (organizationId: number, groupId: number, currentTab: string): string => `/organization/${organizationId}/group/${groupId}/calendar/${currentTab}`
}

export const User = {
	"Profile": {
		"PositionMatch": (organizationId: number, groupId: number, userId: number, ratingId: number): string => `/organization/${organizationId}/group/${groupId}/user/${userId}/profile/development/position-match/${ratingId}`,
		"PositionMatchCompare": (organizationId: number, groupId: number, userId: number, ratingId: number, compareId: number): string => `/organization/${organizationId}/group/${groupId}/user/${userId}/profile/development/position-match/${ratingId}/compare/${compareId}`
	},
	"Registrations": (organizationId: number, currentTab: string): string => `/organization/${organizationId}/user/registrations/${currentTab}`,
	"Submission": (organizationId: number, submissionId: number): string => `/organization/${organizationId}/user/submissions/${submissionId}`,
	"Settings": (organizationId: number, userId: number): string => `/organization/${organizationId}/user/${userId}/settings`
}

export const Registrations = {
	"PackageManagerForms": (organizationId: number): string => `/organization/${organizationId}/registrations/package-manager-forms`,
	"PlayerSelections": (organizationId: number): string => `/organization/${organizationId}/registrations/player-selections`,
	"PlayerSelection": (organizationId: number, formId: number): string => `/organization/${organizationId}/registrations/player-selections/${formId}`,
	"FormSubmissions": (organizationId: number, formId: number): string => `/organization/${organizationId}/registrations/form/${formId}/submissions`,
	"FormSubmission": (organizationId: number, formId: number, submissionId: number): string => `/organization/${organizationId}/registrations/form/${formId}/submissions/${submissionId}`,
	"Category": (organizationId: number, publicUuid: string): string => `/organization/${organizationId}/registrations/category/${publicUuid}`,
	"Edit": (organizationId: number, groupId: number, formId: number): string => `/organization/${organizationId}/registrations/${groupId}/edit/${formId}`,
	"Create": (organizationId: number, groupId: number): string => `/organization/${organizationId}/registrations/${groupId}/create`,
	"CreateRegistration": (organizationId: number, groupId: number): string => `/organization/${organizationId}/registrations/${groupId}/create-registration`,
	"Overview": (organizationId: number, groupId: number, currentTab: string): string => `/organization/${organizationId}/registrations/${groupId}/overview/${currentTab}`,
	"Single": (organizationId: number, groupId: number, formId: number, currentTab: string): string => `/organization/${organizationId}/registrations/${groupId}/${formId}/${currentTab}`,
	"Package": (organizationId: number, groupId: number, formId: number, packageId: number): string => `/organization/${organizationId}/registrations/${groupId}/${formId}/packages/${packageId}`,
	"Activity": (organizationId: number, groupId: number, formId: number, eventGroupId: number, currentTab: string): string => `/organization/${organizationId}/registrations/${groupId}/${formId}/activities/${eventGroupId}/${currentTab}`,
	"Invitations": (organizationId: number, groupId: number): string => `/organization/${organizationId}/registrations/${groupId}/invitations`,
	"Index": (organizationId: number, groupId: number, currentTab: string): string => `/organization/${organizationId}/registrations/${groupId}/${currentTab}`,
	"Public": {
		"Category": (publicUuid: string): string => `/registrations/category/${publicUuid}`
	}
}

export const Forms = {
	"Workspace": (organizationId: number, groupId: number, formId: number): string => `/organization/${organizationId}/registrations/${groupId}/form-workspace/${formId}`
}

export const Form = {
	"Submissions": {
		"Single": (organizationId: number, groupId: number, formId: number, submissionId: number): string => `/organization/${organizationId}/registrations/${groupId}/${formId}/submissions/${submissionId}`
	}
}

export const Management = {
	"Organization": (organizationId: number): string => `/organization/${organizationId}/management/organization`,
	"Overview": (organizationId: number): string => `/organization/${organizationId}/management/overview`,
	"SingleOrganization": (organizationId: number, singleGroupId: number): string => `/organization/${organizationId}/management/group/${singleGroupId}`,
	"Contacts": {
		"Home": (organizationId: number): string => `/organization/${organizationId}/management/contacts`,
		"Duplicates": (organizationId: number, currentTab: string): string => `/organization/${organizationId}/management/contacts/duplicates/${currentTab}`
	},
	"Contact": {
		"Create": (organizationId: number): string => `/organization/${organizationId}/management/contacts/new-contact`
	}
}

export const Sso = {
	"Edit": (organizationId: number, providerId: number): string => `/organization/${organizationId}/settings/sso/${providerId}/edit`,
	"AttributeMapping": (organizationId: number, providerId: number): string => `/organization/${organizationId}/settings/sso/${providerId}/attribute-mapping`
}

export const Settings = {
	"Roles": {
		"Index": (organizationId: number): string => `/organization/${organizationId}/settings/roles`,
		"Create": (organizationId: number): string => `/organization/${organizationId}/settings/roles/create`,
		"Edit": (organizationId: number, roleId: number): string => `/organization/${organizationId}/settings/roles/${roleId}/edit`
	},
	"Users": (organizationId: number, groupId: number, currentTab: string): string => `/organization/${organizationId}/settings/${groupId}/user-management/${currentTab}`,
	"User": {
		"Show": (organizationId: number, groupId: number, userId: number): string => `/organization/${organizationId}/settings/${groupId}/user-management/user/${userId}`
	},
	"Organization": (organizationId: number, groupId: number): string => `/organization/${organizationId}/settings/${groupId}/organization`,
	"V2": (organizationId: number, groupId: number, section: string): string => `/organization/${organizationId}/settings/${groupId}/v2/${section}`,
	"DataImports": {
		"Index": (organizationId: number, groupId: number): string => `/organization/${organizationId}/settings/${groupId}/data-imports`,
		"Single": (organizationId: number, groupId: number, importID: string): string => `/organization/${organizationId}/settings/${groupId}/data-imports/${importID}`
	},
	"Index": (organizationId: number, groupId: number, currentTab: string): string => `/organization/${organizationId}/settings/${groupId}/${currentTab}`
}

export const Statistics = {
	"AttendanceReport": {
		"Show": (organizationId: number, groupId: number, currentTab: string): string => `/organization/${organizationId}/statistics/${groupId}/attendance/${currentTab}`,
		"User": (organizationId: number, groupId: number, userId: number): string => `/organization/${organizationId}/statistics/${groupId}/user/${userId}`
	},
	"Training": (organizationId: number, groupId: number): string => `/organization/${organizationId}/statistics/${groupId}/training`,
	"Beta": (organizationId: number, groupId: number, currentTab: string): string => `/organization/${organizationId}/statistics/${groupId}/beta/${currentTab}`
}

export const Games = {
	"Overview": (organizationId: number, groupId: number): string => `/organization/${organizationId}/games/${groupId}/overview`,
	"Competitions": {
		"Index": (organizationId: number, groupId: number): string => `/organization/${organizationId}/games/${groupId}/competitions`,
		"Show": (organizationId: number, groupId: number, competitionId: number): string => `/organization/${organizationId}/games/${groupId}/competitions/${competitionId}`
	},
	"Opponents": (organizationId: number, groupId: number): string => `/organization/${organizationId}/games/${groupId}/opponents`,
	"Statistics": (organizationId: number, groupId: number, currentTab: string): string => `/organization/${organizationId}/games/${groupId}/${currentTab}`
}

export const Bookings = {
	"Index": (organizationId: number, groupId: number): string => `/organization/${organizationId}/scheduling/${groupId}/bookings`
}

export const Templates = {
	"Index": (organizationId: number, groupId: number): string => `/organization/${organizationId}/scheduling/${groupId}/schedule-templates`,
	"Show": (organizationId: number, groupId: number, id: number): string => `/organization/${organizationId}/scheduling/${groupId}/schedule-templates/${id}`,
	"Print": (organizationId: number, groupId: number, id: number): string => `/organization/${organizationId}/scheduling/${groupId}/schedule-templates/${id}/print`
}

export const Resources = {
	"Index": (organizationId: number, groupId: number, currentTab: string): string => `/organization/${organizationId}/scheduling/${groupId}/resources/${currentTab}`
}

export const TrainingLibrary = {
	"Collection": {
		"Show": (organizationId: number, groupId: number, collectionId: number): string => `/organization/${organizationId}/development/${groupId}/training-library/collections/${collectionId}`
	},
	"Index": (organizationId: number, groupId: number): string => `/organization/${organizationId}/development/${groupId}/training-library`,
	"Show": (organizationId: number, groupId: number, contentGroup: string): string => `/organization/${organizationId}/development/${groupId}/training-library/${contentGroup}`
}

export const VideoLibrary = {
	"Collection": {
		"Show": (organizationId: number, groupId: number, collectionId: number): string => `/organization/${organizationId}/development/${groupId}/video-library/collections/${collectionId}`
	},
	"Index": (organizationId: number, groupId: number): string => `/organization/${organizationId}/development/${groupId}/video-library`,
	"Show": (organizationId: number, groupId: number, contentGroup: string): string => `/organization/${organizationId}/development/${groupId}/video-library/${contentGroup}`
}

export const Development = {
	"Lineups": {
		"Index": (organizationId: number, groupId: number): string => `/organization/${organizationId}/development/${groupId}/lineups`
	}
}

export const PracticePlanner = {
	"Index": (organizationId: number, groupId: number): string => `/organization/${organizationId}/development/${groupId}/practice-planner`,
	"Workspace": (organizationId: number, groupId: number, planId: number): string => `/organization/${organizationId}/development/${groupId}/practice-planner/${planId}/workspace`,
	"Plan": (organizationId: number, groupId: number, planId: number): string => `/organization/${organizationId}/development/${groupId}/practice-planner/${planId}`
}

export const Event = {
	"Create": (organizationId: number): string => `/organization/${organizationId}/events/create`,
	"Created": {
		"Success": (organizationId: number, entityType: string, id: number): string => `/organization/${organizationId}/events/created/${entityType}/${id}`
	},
	"Game": {
		"Edit": (organizationId: number, eventId: number): string => `/organization/${organizationId}/events/${eventId}/game/edit`
	},
	"Edit": (organizationId: number, eventId: number): string => `/organization/${organizationId}/events/${eventId}/edit`,
	"View": (organizationId: number, eventId: number, currentTab: string): string => `/organization/${organizationId}/events/${eventId}/${currentTab}`
}

export const Lineup = {
	"Index": (organizationId: number): string => `/organization/${organizationId}/lineups`,
	"Create": (organizationId: number): string => `/organization/${organizationId}/lineups/create`,
	"Edit": (organizationId: number, lineupId: number): string => `/organization/${organizationId}/lineups/${lineupId}/edit`,
	"Show": (organizationId: number, lineupId: number): string => `/organization/${organizationId}/lineups/${lineupId}`
}

export const EventSeries = {
	"Edit": (organizationId: number, eventSeriesId: number): string => `/organization/${organizationId}/event-series/${eventSeriesId}/edit`,
	"View": (organizationId: number, eventSeriesId: number): string => `/organization/${organizationId}/event-series/${eventSeriesId}`
}

export const CustomLinks = {
	"Show": (organizationId: number, title: string, linkId: number): string => `/organization/${organizationId}/custom-links-${title}/${linkId}`
}

export const Exercise = {
	"Create": (organizationId: number): string => `/organization/${organizationId}/exercises/new`,
	"Edit": (organizationId: number, exerciseId: number): string => `/organization/${organizationId}/exercises/${exerciseId}/edit`,
	"Show": (organizationId: number, exerciseId: number): string => `/organization/${organizationId}/exercises/${exerciseId}`
}

export const TrainingSession = {
	"Create": (organizationId: number): string => `/organization/${organizationId}/training-sessions/create`,
	"Show": (organizationId: number, sessionId: number): string => `/organization/${organizationId}/training-sessions/${sessionId}`,
	"Edit": (organizationId: number, sessionId: number): string => `/organization/${organizationId}/training-sessions/${sessionId}/edit`,
	"Print": (organizationId: number, sessionId: number): string => `/organization/${organizationId}/training-sessions/${sessionId}/print`
}

export const Tournaments = {
	"Index": (organizationId: number): string => `/organization/${organizationId}/tournaments`,
	"Workspace": (organizationId: number, tournamentId: number): string => `/organization/${organizationId}/tournaments/${tournamentId}/workspace`,
	"Series": (organizationId: number, tournamentId: number): string => `/organization/${organizationId}/tournaments/${tournamentId}/playoffs/series`,
	"Show": (organizationId: number, tournamentId: number, currentTab: string): string => `/organization/${organizationId}/tournaments/${tournamentId}/${currentTab}`
}

export const Video = {
	"Show": (organizationId: number, videoId: number): string => `/organization/${organizationId}/videos/${videoId}`,
	"Analyze": (organizationId: number, videoId: number): string => `/organization/${organizationId}/videos/${videoId}/analyze`
}

export const VideoPlaylist = {
	"Show": (organizationId: number, playlistId: number): string => `/organization/${organizationId}/video-playlists/${playlistId}`
}

export const Contact = {
	"Fields": (organizationId: number, userId: number): string => `/organization/${organizationId}/user/${userId}/properties`
}

export const Self = {
	"Billing": (organizationId: number): string => `/organization/${organizationId}/self/billing`,
	"Invoice": (organizationId: number, orderId: number): string => `/organization/${organizationId}/self/billing/invoice/${orderId}`,
	"Memberships": (organizationId: number): string => `/organization/${organizationId}/self/memberships`
}

export const PublicTournament = {
	"Index": (publicID: string): string => `/tournaments/${publicID}`,
	"Series": (publicID: string): string => `/tournaments/${publicID}/playoffs/series`,
	"Show": (publicID: string, currentTab: string): string => `/tournaments/${publicID}/${currentTab}`
}

export const Registration = {
	"Index": (orgSlug: string, guid: string): string => `/registration/${orgSlug}/${guid}`,
	"Form": (orgSlug: string, guid: string): string => `/registration/${orgSlug}/${guid}/register`,
	"PaymentStatus": (orgSlug: string, guid: string): string => `/registration/${orgSlug}/${guid}/payment-status`,
	"Success": (orgSlug: string, guid: string, formSubmissionId: number): string => `/registration/${orgSlug}/${guid}/success/${formSubmissionId}`,
	"Cancel": (orgSlug: string, guid: string, formSubmissionId: number): string => `/registration/${orgSlug}/${guid}/cancel/${formSubmissionId}`,
	"Failed": (orgSlug: string, guid: string): string => `/registration/${orgSlug}/${guid}/failed`,
	"PaymentPending": (orgSlug: string, guid: string): string => `/registration/${orgSlug}/${guid}/payment-pending`
}

export const LoginRedirector = {
	"Index": (): string => `/login`
}

export const SsoRedirector = {
	"Index": (): string => `/sso/redirect`
}